import { AppData } from "@lightningjs/sdk";
import { Helper } from "../helper";
import { Logger } from "../logger";
import AdManagerContext from "./ads-manager-context";
import { AppSetup } from "../app-setup";


class CuePoint {
    cuePointTime:any
    cuePointType:any
    initiatedPrefetch:any
    initiatedAdPlay:any
    playImmediatly:any
    started:any
    completed:any
    currAdIndx:any
    currRequestIndx:any
    adsManagerList:any
    adsStatus:any
    videoInfo:any
    adHandler:any
    state:any
    adEventsCallbackHandler:any
    isPrefetching:any
    totalAds:any
    adStartIntv:any
    adCountNonPodded=0
    totalAdsNonPodded=0


    constructor(cuePointTime:any, cuePointType:any, videoInfo:any, adEventsCallbackHandler:any, adHandler:any) {
        this.cuePointTime = cuePointTime;
        this.cuePointType = cuePointType;
        this.initiatedPrefetch = false;
        this.initiatedAdPlay = false;
        this.playImmediatly = false;
        this.started = false;
        this.completed = false;
        this.currAdIndx = 0;
        this.currRequestIndx = 0;
        this.adsManagerList = [];
        this.adsStatus = [];
        this.videoInfo = videoInfo;
        this.adHandler = adHandler;
        this.state = 'inactive';

        this.adEventsCallbackHandler = adEventsCallbackHandler;
    }

    requestAds = (noOfAds:any, adProviders:any, adsLoader:any, playImmediatly:any, breakPointPos:any) => {
        const { appConfig } = AppData as AppSetup;
        if (this.initiatedPrefetch) return;
        this.playImmediatly = playImmediatly;
        this.initiatedPrefetch = true;
        var timeStamp = Date.now();
        let adsContextCount = noOfAds;        
        let guidIdArr = [];  
        let guidId;
        for(var i=0; i<noOfAds; i++) {
            guidIdArr.push(Helper.guid(this.videoInfo['node_id']));
        }
        if(appConfig?.enableIMAAdPodding) {
            adsContextCount = 1;                        
            guidId = guidIdArr;
        }
        for (var i = 0; i < adsContextCount; i++) {
            if(!appConfig?.enableIMAAdPodding) {
                guidId = guidIdArr[i];
            }
            var adsContext = new AdManagerContext(
                this,
                this.cuePointType,
                adProviders,
                i,
                this.cuePointTime,
                adsLoader,
                this.videoInfo,
                guidId,
                breakPointPos,
                timeStamp,
                this.adHandler,
                appConfig?.enableIMAAdPodding
            );
            this.isPrefetching = true;
            this.totalAds = adsContextCount;
            this.adsManagerList.push(adsContext);
            this.adsStatus.push('fetching');
            if (i === 0) {
                adsContext.requestAds();
            }
        }
        this.state = 'requested';
    }

    startAd = () => {
        if (this.initiatedAdPlay) return;
        this.initiatedAdPlay = true;
        this.state = 'started';
        this._playAd();
    }

    _requestNextAd = () => {
        const nextIdx = this.currRequestIndx + 1;
        if (nextIdx < this.adsManagerList.length) {
            this.currRequestIndx = nextIdx;
            Logger.printLog('info', 'CuePoint: _requestNextAd: requesting index ' + nextIdx, '');
            this.adsManagerList[nextIdx].requestAds();
        }
    }

    _playAd = () => {
        const { appConfig, platform, appState } = AppData as AppSetup;
        const app = appState?.getApp();
        let adObj = app?.adObj;
        let ads = app?.ads;
        var adStatus = this.adsStatus[this.currAdIndx];
        var adsContext = this.adsManagerList[this.currAdIndx];
        Logger.printLog('info', 'CuePoint: _playAd: ' + this.currAdIndx + ', status: ' + adStatus,'');
        if (adStatus.indexOf('error') > -1) {
            adsContext.hitTrackers('error');
            this._playNextAdOrContent();
        } else if (adStatus == 'complete') {
            //adsContext.hitTrackers('complete');
            this._playNextAdOrContent();
        }  else if (adStatus == 'allAdsCompleted' || adStatus == 'contentResumeRequested') {
            if(appConfig?.enableIMAAdPodding) {
                this._playNextAdOrContent();
            }            
        } else if (adStatus == 'loaded') {
            if (!ads.adsInitialized) {
                this.adHandler.adDisplayContainer.initialize();
                ads.adsInitialized = true;
            }
            //adsContext.adsManager.init(appUIConfig.winW, appUIConfig.winH, google.ima.ViewMode.NORMAL);
            adsContext.startAd();
            var ref = this;
            this.clearAdStartIntv();
            Logger.printLog('data', 'ad start timeout - init','');
            this.adStartIntv = setTimeout(function(){
               Logger.printLog('data', 'ad start timeout - trigger','');
                ref.skipCurrentAd();
            }, appConfig.adSkipCheckInterval);
        }
    }

    clearAdStartIntv = () => {
        Logger.printLog('data', 'ad start timeout - cleared','');
        clearTimeout(this.adStartIntv);
    }

    _playNextAdOrContent = () => {

        Logger.printLog('info', '_playNextAdOrContent: currAdIndx : totalAds ' + this.currAdIndx + ' : ' + (this.totalAds - 1),'');
        if (this.currAdIndx < this.totalAds - 1) {
            this.currAdIndx++;
            this._playAd();
        } else {
            if (this.cuePointType == 'preroll' && this._isAllAdsInvalid()) {
                this.adHandler.onContentResumeRequested();
            } else/* if (this.started)*/ {
                this.adHandler.onContentResumeRequested();
            }
            this.completed = true;
        }

    }

    _isAllAdsInvalid = () => {
        var errorCount = 0;
        for (var i = 0; i < this.adsStatus.length; i++) {
            var adStatus = this.adsStatus[i]
            if (adStatus.indexOf('error') > -1) {
                errorCount++;
            }
        }
        if (this.totalAds == errorCount) {
            return true;
        }
        return false;
    }

    getAdpodInfo = () => {
        var totalAds = this.totalAds;
        var adPosition = 0;
        for (var i = 0; i < this.adsStatus.length; i++) {
            var adStatus = this.adsStatus[i];
            if (adStatus == 'started' || adStatus == 'complete' || adStatus == 'error_adPlayError') {
                adPosition++;
            }
            if (adStatus == 'error_adLoadError') {
                totalAds--;
            }
        }
        return { adPosition: adPosition, totalAds: totalAds };
    }

    getAdpodData = () => {

        var adPodData = {
            podId: -1,
            totalAds: this.totalAds,
            errors: 0,
            loaded: 0,
            startedIndex: -1,
            nextPlayableIndex: -1,
            pod:0
        }

        var startedIndx = -1;
        var loadedIndx = -1;
        var isPodIdSet = false;
        var isNextIdSet = false;
        for (var i = 0; i < this.adsStatus.length; i++) {
            var adStatus = this.adsStatus[i];
            if (adStatus == 'started') {
                startedIndx = i;
                adPodData.startedIndex = i;
                adPodData.pod = i;
                isPodIdSet = true;
            } else if (adStatus == 'loaded') {
                loadedIndx = i;
                adPodData.pod = i;
                isPodIdSet = true;
                adPodData.loaded++;
            } else if (adStatus.indexOf('error') > -1) {
                adPodData.errors++;
            }
            if (adStatus == 'loaded' && i > startedIndx && i >= loadedIndx) {
                adPodData.nextPlayableIndex = i;
                isNextIdSet = true;
            }
        }

        return adPodData;
    }

    skipCurrentAd = () => {
        this.adsStatus[this.currAdIndx] = 'error_' + google.ima.AdError.Type.AD_PLAY;
        var adsContext = this.adsManagerList[this.currAdIndx];
        adsContext.stopAd();
    }

    pause = () => {
        //this.adsStatus[this.currAdIndx] = 'error_' + google.ima.AdError.Type.AD_PLAY;
        var adsContext = this.adsManagerList[this.currAdIndx];
        adsContext.pause();
    }

    resume = () => {
        this.adsStatus[this.currAdIndx] = 'error_' + google.ima.AdError.Type.AD_PLAY;
        var adsContext = this.adsManagerList[this.currAdIndx];
        adsContext.resume();
    }

    onAdEvent = (event:any, podIndex:any) => {
        const { appConfig } = AppData as AppSetup;
        if(event.type!="adProgress"){
            Logger.printLog('data', 'cuepoint.ts IMA onAdEvent ' + event.type+' , ' + podIndex,'');
        }
        if (event.type == google.ima.AdEvent.Type.LOADED) {
            Logger.printLog('info', 'CuePoint: Loaded: ' + podIndex,'');
            this.adsStatus[podIndex] = 'loaded';
            Logger.printLog('info', 'CuePoint: Loaded: enableIMAAdPodding : ',appConfig?.enableIMAAdPodding);
            if(appConfig?.enableIMAAdPodding==false) {
                this.totalAdsNonPodded = this.totalAdsNonPodded+1;
                Logger.printLog('info', 'CuePoint: Loaded: totalAdsNonPodded : ',this.totalAdsNonPodded);                
            }
            if (this.playImmediatly && !this.initiatedAdPlay && !this.started && this.currAdIndx == podIndex) {
                this.startAd();
            } else if (this.initiatedAdPlay && this.currAdIndx == podIndex) {
                this._playAd();
            }
        } else if (event.type == google.ima.AdErrorEvent.Type.AD_ERROR) {
            //var errorCode = event.getError().getErrorCode();
            var errorType = event.getError().getType();
            if (errorType == google.ima.AdError.Type.AD_PLAY) {
                if (this.currAdIndx <= this.totalAds - 1) {
                    this.adsStatus[podIndex] = 'error_' + google.ima.AdError.Type.AD_PLAY;
                    this._requestNextAd();
                }
            }
            //console.log("Cuepoint: " + google.ima.AdErrorEvent.Type.AD_ERROR);
            return;
        } else if (event.type == google.ima.AdEvent.Type.IMPRESSION) {
            if(appConfig?.enableIMAAdPodding==false) {
                this.adCountNonPodded = this.adCountNonPodded+1;
                Logger.printLog('info', 'CuePoint: IMPRESSION: adCountNonPodded / totalAdsNonPodded : ',`${this.adCountNonPodded} / ${this.totalAdsNonPodded}`);
                $('.custom-ad-number').text(`${this.adCountNonPodded} / ${this.totalAdsNonPodded}`);
            }
        } else if (event.type == google.ima.AdEvent.Type.STARTED) {
            this.adsStatus[podIndex] = 'started';
            //console.log("Cuepoint:  " + google.ima.AdEvent.Type.STARTED);
        } else if (event.type == google.ima.AdEvent.Type.COMPLETE) {
            this.adsStatus[this.currAdIndx] = 'complete';
            var adsContext = this.adsManagerList[this.currAdIndx];
            //console.log("Cuepoint:  " + google.ima.AdEvent.Type.COMPLETE);
            adsContext.hitTrackers('complete');
            this._requestNextAd();
            //Hit Complete Tracker.
        } else if (event.type == google.ima.AdEvent.Type.ALL_ADS_COMPLETED) {
            // this event will not be sent to the event listener.
            if(appConfig?.enableIMAAdPodding) {                
                this.adsStatus[this.currAdIndx] = 'allAdsCompleted';
            }
            this._playAd()
            return;
        } else if (event.type == google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED) {
            if (this.started) {
                return;
            }
            this.state = 'playing';
            this.started = true;
            //console.log("Cuepoint: " + google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED)
        } else if (event.type == google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED) {
            // if(this.adsStatus[podIndex].indexOf('error') > -1){
            // } else if(this.adsStatus[podIndex]=='complete'){
            // } else {
            //     this.adsStatus[podIndex]='complete';
            // }
            // //console.log("Cuepoint:  " + google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED + ':: ' + this.currAdIndx);
            // if (this.currAdIndx < this.totalAds - 1) {
            //     //do not send the content resume event, will be sent finally after all ads played.
            //     this._playAd();
            //     return;
            // } else {
            //     this.completed = true;
            //     this.state = 'completed';
            // }
            if(appConfig?.enableIMAAdPodding) {
                this.adsStatus[this.currAdIndx] = 'contentResumeRequested';
            }
            return

        }

        var adPodInfo = this.getAdpodInfo();
        this.adEventsCallbackHandler(event, adPodInfo);
    }

    onAdError = (event:any, podIndex:any) => {
        // This error will be triggered only on the Ad request errors.
        //empty ad, tag url 404, etc.


        var errorType = event.getError().getType();


        //console.log("SURESH: " + google.ima.AdError.Type.AD_LOAD + ', Type: ' + errorType);
        if (errorType == google.ima.AdError.Type.AD_LOAD) {
            this.adsStatus[podIndex] = 'error_' + google.ima.AdError.Type.AD_LOAD;
            this._requestNextAd();
            if (this.playImmediatly && !this.initiatedAdPlay && !this.started && podIndex == 0) {
                this.startAd();
            } else if (this.initiatedAdPlay && this.currAdIndx == podIndex) {
                this._playAd();
            }
        }
        // if (this.playImmediatly && !this.started) {
        //     if(this._isAllAdsCompleted) {
        //         //this.adEventsCallbackHandler(google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED, podIndex, this.totalAds);
        //         customIma.onContentResumeRequested();
        //     }
        // } else if (this.initiatedAdPlay && !this.started) {
        //     this._playAd();
        // }
        //this.adEventsCallbackHandler(event, podIndex, this.totalAds);
    }

    resetPrefetch = () => {
        for (var i = 0; i < this.adsManagerList.length; i++) {
            var adsmanager = this.adsManagerList[i];
            adsmanager.destroy();
        }
        this.initiatedPrefetch = false;
        this.initiatedAdPlay = false;
        this.playImmediatly = false;
        this.started = false;
        this.completed = false;
        this.currAdIndx = 0;
        this.currRequestIndx = 0;
        this.adsManagerList = [];
        this.adsStatus = [];
        this.adHandler = null;
    }

    destroy = () => {
        for (var i = 0; i < this.adsManagerList.length; i++) {
            var adsmanager = this.adsManagerList[i];
            adsmanager.destroy();
        }
        this.adsManagerList = null;
        this.videoInfo = null;
        this.adEventsCallbackHandler = null;
        this.clearAdStartIntv();
    }

    hitRequestTrackers = () => {
        var adsContext = this.adsManagerList[this.currAdIndx];
        //adsContext.hitTrackers('error');
        adsContext.hitTrackers('requested');
    }



}

export default CuePoint;
